let todayOrLater = () => {
  return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModelController) => {
        ngModelController.$validators.todayOrLater = function(modelValue, viewValue) {
          if (ngModelController.$isEmpty(modelValue) === true) {
              return true;
          }

          let date = moment(modelValue).startOf('day');

          return date.isSameOrAfter(moment().startOf('day'));
        }
      }
  };
};

todayOrLater.$inject = [];

export default todayOrLater;



// WEBPACK FOOTER //
// ./client/app/common/field-validators/today-or-later.js